import { useState } from "react";

import { LoyaltyMessageEditForm } from "src/app/features/LoyaltyMessage/components/forms/LoyaltyMessageEditForm";
import { useLoyaltyMessageLoadQuery } from "src/app/features/LoyaltyMessage/services/server/LoyaltyMessageApi";
import { ActionBar } from "../../../../components/ActionBar/ActionBar";
import { PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { NoAccessLayout } from "../../../../components/AppLayout/components/Content/components/NoAccessLayout";
import { FPage, FPageContent, FPageHeader } from "../../../../components/AppLayout/components/FPageLayout";
import { HistoryButton } from "../../../../components/FeatureButtons/HistoryButton";
import { RefreshButton } from "../../../../components/FeatureButtons/RefreshButton";
import { SubmitButton } from "../../../../components/FeatureButtons/SubmitButton";
import { getAssignedDataGroup } from "../../../../core/router/auth";
import { canAccess } from "../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import { FORM_ACTION } from "../../../../core/router/types/routerTypes";

export const LoyaltyMessageEditFormPage = () => {
    const [runSubmit, setRunSubmit] = useState(0);
    const triggerFormSubmit = () => setRunSubmit(runSubmit + 1);
    const hasWriteAccess = canAccess(ResourceName.LOYALTY_MESSAGES, "canWrite");
    const hasAccess = canAccess(ResourceName.LOYALTY_MESSAGES, "canRead");
    const { data: entity } = useLoyaltyMessageLoadQuery({});
    const dataGroup = getAssignedDataGroup();
    const historyUrl = entity?.id
        ? `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.LOYALTY_MESSAGES}/${entity.id}/${FORM_ACTION.HISTORY}`
        : undefined;

    return (
        <FPage>
            {hasAccess ? (
                <>
                    <FPageHeader>
                        <PageTitle translationKey="page.title.loyaltyMessageEditFormPage" />
                        <ActionBar>
                            <SubmitButton isDisabled={!hasWriteAccess} onClick={triggerFormSubmit} />
                            <HistoryButton url={historyUrl} />
                            <RefreshButton isDisabled={false} />
                        </ActionBar>
                    </FPageHeader>
                    <FPageContent>
                        <LoyaltyMessageEditForm runSubmit={runSubmit} />
                    </FPageContent>
                </>
            ) : (
                <NoAccessLayout />
            )}
        </FPage>
    );
};
